import { useCallback, useEffect, useState } from "react";
import { auditApi } from "../services/auditApi.js";
import type { EntityRecord } from "../types/api.types.js";
import { normalizeUserSafeApiError } from "../core/api/apiErrorNormalizer.js";

export function useCmtsAuditTrail(module: string, entityId?: string | undefined): {
  readonly rows: readonly EntityRecord[];
  readonly loading: boolean;
  readonly error?: string | undefined;
  readonly refresh: () => Promise<void>;
} {
  const [rows, setRows] = useState<readonly EntityRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    try {
      const result = await auditApi.list({ page: 1, pageSize: 50, filters: { module, entityId } });
      setRows(result.items);
    } catch (err) {
      setRows([]);
      setError(normalizeUserSafeApiError(err).userMessage || "Audit trail could not be loaded.");
    } finally {
      setLoading(false);
    }
  }, [entityId, module]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { rows, loading, error, refresh };
}
